    <div class="overlay" *ngIf="(loading.isVisible$ | async)">
      <div class="loader">
        <mat-progress-spinner
          mode="indeterminate"
          [diameter]="40"
          [strokeWidth]="4"
          class="custom-spinner">
        </mat-progress-spinner>
        <div class="label">Loading...</div>
      </div>
    </div>
